export const TAB_SESSION_MANAGER = 'sessionManager';
export const TAB_FORM_BUILDER = 'formBuilder';
